// @flow
import { useEffect } from 'react';
import Debug from 'debug';
import OlZoom from 'ol/control/Zoom';
import { useMap } from '../context';

const debug = Debug('amms:modules:openlayers:controls:zoom');



type Props = $ReadOnly<{
    duration?: number,
    delta?: number,
    className?: string
}>;

function Zoom({ duration, delta, className }: Props) {
    const map = useMap();

    useEffect(() => {
        let _zoom;
        if(map) {
            _zoom = new OlZoom({
                duration,
                delta,
                className
            });

            map.addControl(_zoom);
        }

        return () => {
            if(map && _zoom) {
                map.removeControl(_zoom);
            }
        }
    }, [map, duration, delta]);

    return null;
}

export default Zoom;